var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['button', 'handle', { active: !_vm.disabled && _vm.value }],on:{"click":_vm.onClick}},[_c('i',{class:['fas', 'icon', ("fa-" + _vm.icon)]}),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }